import { createSlice } from "@reduxjs/toolkit";

const frequencyInitialState = {
  frequency: "every-month",
};

const frequencySlice = createSlice({
  name: "frequency",
  initialState: frequencyInitialState,
  reducers: {
    selectFrequency: (state, action) => {
      state.frequency = action.payload;
    },
  },
});

export const { selectFrequency } = frequencySlice.actions;

export default frequencySlice.reducer;
